import QrMenu from './QrMenu';

export default QrMenu;
